import React, { useEffect, useRef } from "react";

// Simple intersection observer wrapper to animate elements into view using .reveal / .is-visible classes
const Reveal = ({
  children,
  className = "",
  threshold = 0.15,
  rootMargin = "0px 0px -50px 0px",
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            node.classList.add("is-visible");
            obs.unobserve(node);
          }
        });
      },
      { threshold, rootMargin }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return (
    <div ref={ref} className={`reveal ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
